import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useIsOptionRichText } from '../Common/useIsOptionRichText';
import { IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

import s from './SingleChoiceAnswerItem.scss';

export interface ISingleChoiceAnswerItemProps {
    option: IAnswerOption;
    onSelectOption: () => void;
}

export const SingleChoiceAnswerItem = React.memo(
	({ option, onSelectOption }: ISingleChoiceAnswerItemProps): JSX.Element => {
		useStyles(s);
		const isOptionRichText = useIsOptionRichText(option.text);

		if (!option) return null;

		return isOptionRichText ? (
			<div
				className={`sl-single-choice-item ${option.status}`}
				onClick={onSelectOption}
				dangerouslySetInnerHTML={{
					__html: option.text,
				}}
			/>
		) : (
			<div
				className={`sl-single-choice-item ${option.status}`}
				onClick={onSelectOption}
			>
				{option.text}
			</div>
		);
	},
);
